export const isClearResponse = (message) => {
    return message.error === null && typeof message.id === 'number';
};
